export default __webpack_public_path__ + "static/media/key.0248f92e.svg";